(function () {
  'use strict';

  var component = {
    template:'<div class="hq-lighting-title" hl-sticky ng-class="{ \'hq-lighting-title--small\': $ctrl.small, \'hq-lighting-title--gray\': $ctrl.gray }"><div class="hq-lighting-title__container"><h1 tabindex="0" id="desc-question-{{$ctrl-stepName}}" data-ng-bind-html="($ctrl.translateKey + \'_TITLE\' | uppercase) | translate"></h1><button data-ng-if="$ctrl.action" data-ng-click="$ctrl.action()" hq-tools-lighting-focus-on="modal-open" tabindex="0" class="hq-lighting-title__info-button">{{\'INFORMATION\' | translate}}</button></div></div>',
    bindings: {
      translateKey: '@',
      small: '@',
      gray: '@',
      action: '&?',
    },
  };

  angular
    .module('hq.tools.lighting')
    .component('hqToolsLightingTitle', component);
}());
